import { AxiosResponse } from 'axios'

import base from './base'

export const create = (): Promise<AxiosResponse<any>> => {
  return base.post('/v1/term_of_use_agreements')
}
